<div class="layout-wrapper" [class.page-container-blur]="underConstruction" [ngClass]="containerClass"
  [style.pointer-events]="underConstruction ? 'none' : 'all'">
  <app-header></app-header>
  <div class="content-wrapper">
    <!-- <app-sidebar></app-sidebar> -->
     <div>
        <app-lucky-winner-banner *ngIf="openLuckyWinnerSubscribePopup"/>
        <router-outlet></router-outlet>
     </div>
  </div>
  <app-footer></app-footer>
</div>

<div class="under-construction web-center" *ngIf="underConstruction">
  <div>
    <img src="assets/images/Logo.png" style="height: 20rem;width: 32rem;object-fit: contain;" />
  </div>
  <p class="Rubik-Bold fs-3 text-black" style="font-weight: 700;">We apologize for the inconvenience. We are currently experiencing a significant issue with our software and are working diligently to resolve it. 
  </p>
  <p class="Rubik-Bold fs-3 text-black"  style="font-weight: 700;">We will be back soon.</p>
</div>